import { Injectable, Inject, Optional, ɵɵdefineInjectable, ɵɵinject, forwardRef, Component, ViewChild, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { __awaiter } from 'tslib';
import { Web, SPHttpClient } from '@pnp/sp';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/material/form-field';
import * as ɵngcc4 from '@angular/material/core';
import * as ɵngcc5 from '@angular/material/chips';
import * as ɵngcc6 from '@angular/material/autocomplete';
import * as ɵngcc7 from '@angular/material/icon';
import * as ɵngcc8 from '@angular/material/progress-bar';
import * as ɵngcc9 from '@angular/material/dialog';
import * as ɵngcc10 from '@angular/material/checkbox';
import * as ɵngcc11 from '@angular/material/input';
import * as ɵngcc12 from '@angular/material/table';

const _c0 = ["userInput"];
const _c1 = ["chipList"];
function PwoScdComponent_mat_chip_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-chip", 10);
    ɵngcc0.ɵɵlistener("removed", function PwoScdComponent_mat_chip_5_Template_mat_chip_removed_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const user_r6 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.remove(user_r6)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "mat-icon", 11);
    ɵngcc0.ɵɵtext(3, "cancel");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("selectable", true)("removable", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", user_r6.Title, " ");
} }
function PwoScdComponent_mat_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 12);
    ɵngcc0.ɵɵelement(1, "mat-progress-bar", 13);
    ɵngcc0.ɵɵelementEnd();
} }
function PwoScdComponent_mat_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "small");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", user_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", user_r9.firstName, " ", user_r9.surName, " | ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(user_r9.department);
} }
const _c2 = [[["mat-hint"]], [["mat-error"]]];
const _c3 = ["mat-hint", "mat-error"];
function PwoScdPickerComponent_mat_header_cell_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-header-cell");
} }
function PwoScdPickerComponent_mat_cell_30_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-cell")(1, "mat-checkbox", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function PwoScdPickerComponent_mat_cell_30_Template_mat_checkbox_ngModelChange_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r16); const element_r14 = restoredCtx.$implicit; return ɵngcc0.ɵɵresetView(element_r14.selected = $event); })("change", function PwoScdPickerComponent_mat_cell_30_Template_mat_checkbox_change_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r16); const element_r14 = restoredCtx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17.changeSelected(element_r14, $event)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const element_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", element_r14.selected);
} }
function PwoScdPickerComponent_mat_header_cell_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-header-cell")(1, "span");
    ɵngcc0.ɵɵtext(2, "Nachname");
    ɵngcc0.ɵɵelementEnd()();
} }
function PwoScdPickerComponent_mat_cell_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-cell");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r18 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(element_r18.surName);
} }
function PwoScdPickerComponent_mat_header_cell_35_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-header-cell")(1, "span");
    ɵngcc0.ɵɵtext(2, "Vorname");
    ɵngcc0.ɵɵelementEnd()();
} }
function PwoScdPickerComponent_mat_cell_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-cell");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(element_r19.firstName);
} }
function PwoScdPickerComponent_mat_header_cell_38_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-header-cell")(1, "span");
    ɵngcc0.ɵɵtext(2, "Mail");
    ɵngcc0.ɵɵelementEnd()();
} }
function PwoScdPickerComponent_mat_cell_39_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-cell");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r20 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(element_r20.mail);
} }
function PwoScdPickerComponent_mat_header_cell_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-header-cell")(1, "span");
    ɵngcc0.ɵɵtext(2, "Abteilung");
    ɵngcc0.ɵɵelementEnd()();
} }
function PwoScdPickerComponent_mat_cell_42_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-cell");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r21 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(element_r21.department);
} }
function PwoScdPickerComponent_mat_header_row_43_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-header-row");
} }
function PwoScdPickerComponent_mat_row_44_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-row");
} }
function PwoScdPickerComponent_div_45_ng_container_2_mat_chip_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-chip", 33);
    ɵngcc0.ɵɵlistener("removed", function PwoScdPickerComponent_div_45_ng_container_2_mat_chip_1_Template_mat_chip_removed_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const user_r24 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r26.changeSelected(user_r24, { checked: false })); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 34);
    ɵngcc0.ɵɵtext(3, "cancel");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", user_r24.firstName + " " + user_r24.surName || user_r24.name, " ");
} }
function PwoScdPickerComponent_div_45_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PwoScdPickerComponent_div_45_ng_container_2_mat_chip_1_Template, 4, 1, "mat-chip", 32);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const user_r24 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", user_r24.firstName);
} }
function PwoScdPickerComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "mat-chip-list");
    ɵngcc0.ɵɵtemplate(2, PwoScdPickerComponent_div_45_ng_container_2_Template, 2, 1, "ng-container", 31);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r13.selectedUsers);
} }
function PwoScdPeopleAutocompleteComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function PwoScdPeopleAutocompleteComponent_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.openPicker()); });
    ɵngcc0.ɵɵelement(1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} }
function PwoScdPeopleAutocompleteComponent_mat_option_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-option", 7);
    ɵngcc0.ɵɵlistener("onSelectionChange", function PwoScdPeopleAutocompleteComponent_mat_option_5_Template_mat_option_onSelectionChange_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.select(item_r5)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r5.display);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.display, " ");
} }
const _c4 = function (a0) { return { "disabled": a0 }; };
class PwoScdService {
    /**
     * PwoScdService - searches users in the SCD
     *
     * This uses the AWS SCD Service. If you use SharePoint (not the Auth GMS App), you need an
     * API key, contact Joey Kilpatrick! Provide the API Key in the module that imports the
     * PwoScdModule:
     * <code>
     * providers: [
     *  { provide: 'scdApiKey', useValue: 'YOUR-API-KEY-HERE' }
     * ]
     * </code>
     *
     * https://confluence.gms.siemens.cloud/display/OMWiki/AWS+SCD+Service
     *
     *
     * If you are using the Auth GMS App, you have to contact Joey Kilpatrick to setup the SCD
     * service for it: https://confluence.gms.siemens.cloud/display/OMWiki/AWS+SCD+Service+Proxy+for+Auth-GMS-App
     *
     * The Bearer token will be included automatically, make sure that you DON'T specify an API key
     * so that the correct endpoint is used.
     *
     * The Auth GMS client stores the access key in the local storage under 'access_key' which is
     * detected automatically. However, if you changed the local storage key of your access token,
     * you can provide it: `{ provide: 'accessTokenKey', useValue: 'custom_access_token_location' }`
     * @param {?} apiKey
     * @param {?} accessTokenKey
     */
    constructor(apiKey, accessTokenKey) {
        this.apiKey = apiKey;
        this.accessTokenKey = accessTokenKey;
        // public scdServiceUrl = 'https://pwo-db.gms.siemens.com:8007/Default.aspx'; DEPRECATED!!!
        this.scdServiceUrl = 'https://wcs-scd.siemens.cloud/persons';
        this.authScdServiceUrl = 'https://auth.wcs-scd.siemens.cloud/persons';
    }
    /**
     * @param {?} firstName
     * @param {?} surName
     * @param {?} eMail
     * @return {?}
     */
    searchUser(firstName, surName, eMail) {
        /** @type {?} */
        let url = '';
        if (firstName) {
            firstName = firstName.trim().toLowerCase();
            url += '?firstName=' + firstName + '*';
            if (surName) {
                surName = surName.trim().toLowerCase();
                url += '&surName=' + surName + '*';
                if (eMail) {
                    eMail = eMail.trim().toLowerCase();
                    url += '&mail=' + eMail + '*';
                }
            }
            else if (eMail) {
                eMail = eMail.trim().toLowerCase();
                url += '&mail=' + eMail + '*';
            }
        }
        else if (surName) {
            surName = surName.trim().toLowerCase();
            url += '?surName=' + surName + '*';
            if (eMail) {
                eMail = eMail.trim().toLowerCase();
                url += '&mail=' + eMail + '*';
            }
        }
        else if (eMail) {
            eMail = eMail.trim().toLowerCase();
            url += '?mail=' + eMail + '*';
        }
        return this.get(url);
    }
    /**
     * @param {?} list
     * @return {?}
     */
    searchByGID(list) {
        return new Promise((/**
         * @param {?} resolve
         * @return {?}
         */
        resolve => {
            /** @type {?} */
            let result = [];
            for (const e of list) {
                this.getByGID(e.scdGid).then((/**
                 * @param {?} res
                 * @return {?}
                 */
                res => {
                    result = result.concat(res.person);
                    if (result.length === list.length) {
                        resolve(result);
                    }
                }));
            }
        }));
    }
    /**
     * @param {?} gid
     * @return {?}
     */
    getByGID(gid) {
        return this.get('?gid=' + gid + '*');
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    get(url) {
        /** @type {?} */
        const headers = new Headers();
        if (this.apiKey) {
            headers.set('x-api-key', this.apiKey);
            url = this.scdServiceUrl + url;
        }
        else {
            /** @type {?} */
            const token = localStorage.getItem(this.accessTokenKey || 'access_token');
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
                url = this.authScdServiceUrl + url;
            }
            else {
                throw new Error('No access token found in local storage! Are you using the Auth GMS App? Otherwise you need to provide an API Key!');
            }
        }
        return fetch(url, { headers }).then((/**
         * @param {?} resp
         * @return {?}
         */
        resp => resp.json()));
    }
}
PwoScdService.ɵfac = function PwoScdService_Factory(t) { return new (t || PwoScdService)(ɵngcc0.ɵɵinject('scdApiKey', 8), ɵngcc0.ɵɵinject('accessTokenKey', 8)); };
PwoScdService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PwoScdService, factory: PwoScdService.ɵfac, providedIn: 'root' });
/** @nocollapse */
PwoScdService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: ['scdApiKey',] }, { type: Optional }] },
    { type: String, decorators: [{ type: Inject, args: ['accessTokenKey',] }, { type: Optional }] }
];
/** @nocollapse */ PwoScdService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PwoScdService_Factory() { return new PwoScdService(ɵɵinject("scdApiKey", 8), ɵɵinject("accessTokenKey", 8)); }, token: PwoScdService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: ['scdApiKey']
            }, {
                type: Optional
            }] }, { type: String, decorators: [{
                type: Inject,
                args: ['accessTokenKey']
            }, {
                type: Optional
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    PwoScdService.prototype.scdServiceUrl;
    /** @type {?} */
    PwoScdService.prototype.authScdServiceUrl;
    /** @type {?} */
    PwoScdService.prototype.apiKey;
    /** @type {?} */
    PwoScdService.prototype.accessTokenKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoScdSearchService {
    /**
     * PwoScdSearchService - searches users in the SCD, looks up users in the SP Active Directory
     *
     * This uses the AWS SCD Service. If you use SharePoint (not the Auth GMS App), you need an
     * API key, contact Joey Kilpatrick! Provide the API Key in the module that imports the
     * PwoScdModule:
     * <code>
     * providers: [
     *  { provide: 'scdApiKey', useValue: 'YOUR-API-KEY-HERE' }
     * ]
     * </code>
     *
     * https://confluence.gms.siemens.cloud/display/OMWiki/AWS+SCD+Service
     *
     *
     * If you are using the Auth GMS App, you have to contact Joey Kilpatrick to setup the SCD
     * service for it: https://confluence.gms.siemens.cloud/display/OMWiki/AWS+SCD+Service+Proxy+for+Auth-GMS-App
     *
     * The Bearer token will be included automatically, make sure that you DON'T specify an API key
     * so that the correct endpoint is used.
     *
     * The Auth GMS client stores the access key in the local storage under 'access_key' which is
     * detected automatically. However, if you changed the local storage key of your access token,
     * you can provide it: `{ provide: 'accessTokenKey', useValue: 'custom_access_token_location' }`
     * @param {?} apiKey
     * @param {?} accessTokenKey
     */
    constructor(apiKey, accessTokenKey) {
        this.apiKey = apiKey;
        this.accessTokenKey = accessTokenKey;
        // base = 'https://pwo-db.gms.siemens.com:8007/Default.aspx'; DEPRECATED!!!
        this.scdServiceUrl = 'https://wcs-scd.siemens.cloud/persons';
        this.authScdServiceUrl = 'https://auth.wcs-scd.siemens.cloud/persons';
    }
    /**
     * @param {?} spWeburl
     * @return {?}
     */
    setup(spWeburl) {
        this.spWeburl = spWeburl;
        this.web = new Web(spWeburl);
    }
    /**
     * @param {?} term
     * @return {?}
     */
    searchUser(term) {
        term = term.trim().toLowerCase();
        term = term.replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue');
        if (!term) {
            return Promise.reject(new Error('Search term is empty'));
        }
        if (term.length === 8 && /(z|x)\w+/.test(term)) {
            return this.getUserByGID(term);
        }
        else if (term.includes('.') || term.includes('@')) {
            return this.getUserByMail(term);
        }
        else {
            return this.getUserByName(term);
        }
    }
    /**
     * @param {?} gid
     * @return {?}
     */
    getUserByGID(gid) {
        return this.get('?gid=' + gid);
    }
    /**
     * @param {?} term
     * @return {?}
     */
    getUserByName(term) {
        /** @type {?} */
        let surname;
        /** @type {?} */
        let firstname;
        if (term.includes(',')) {
            [surname, firstname] = term.replace(/ +/g, '*').split(/\**,\**/); // replace spaces with asterisks
            return this.get('?surName=' + surname + '*&firstName=' + firstname + '*');
        }
        else if (term.includes(' ')) {
            [firstname, surname] = term.split(' ');
            return this.get('?surName=' + surname + '*&firstName=' + firstname + '*');
        }
        else {
            return this.get('?surName=' + term + '*');
        }
    }
    /**
     * @param {?} mail
     * @return {?}
     */
    getUserByMail(mail) {
        return this.get('?mail=' + mail + '*');
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    get(url) {
        return __awaiter(this, void 0, void 0, /** @this {!PwoScdSearchService} */ function* () {
            /** @type {?} */
            const headers = new Headers();
            if (this.apiKey) {
                headers.set('x-api-key', this.apiKey);
                url = this.scdServiceUrl + url;
            }
            else {
                /** @type {?} */
                const token = localStorage.getItem(this.accessTokenKey || 'access_token');
                if (token) {
                    headers.set('authorization', `Bearer ${token}`);
                    url = this.authScdServiceUrl + url;
                }
                else {
                    throw new Error('No access token found in local storage! Are you using the Auth GMS App? Otherwise you need to provide an API Key!');
                }
            }
            /** @type {?} */
            const resp = yield fetch(url, { headers });
            /** @type {?} */
            const obj = yield resp.json();
            return obj.records || obj;
        });
    }
    /**
     * Searches the specified user with it's mail in the ActiveDirectory and returns the SP User object of the user.
     * If the user does not exist on the site collection, this will create it and return the SP User object.
     *
     * @param {?} user The user to be searched, need to have property mail
     * @return {?}
     */
    getSPUser(user) {
        /** @type {?} */
        const client = new SPHttpClient();
        /** @type {?} */
        const searchString = user.mail;
        /** @type {?} */
        const endpointUrl = `${this.spWeburl}` +
            `/_api/SP.UI.ApplicationPages.ClientPeoplePickerWebServiceInterface.clientPeoplePickerSearchUser`
                .replace(/\/\//g, '/');
        return client.post(endpointUrl, {
            headers: {
                'Accept': `application/json; odata=verbose`
            },
            body: JSON.stringify({
                queryParams: {
                    __metadata: {
                        type: 'SP.UI.ApplicationPages.ClientPeoplePickerQueryParameters'
                    },
                    AllowEmailAddresses: true,
                    AllowMultipleEntities: false,
                    AllUrlZones: false,
                    MaximumEntitySuggestions: 50,
                    PrincipalSource: 15,
                    PrincipalType: 15,
                    QueryString: searchString
                }
            })
        }).then((/**
         * @param {?} response
         * @return {?}
         */
        response => response.json()))
            .then((/**
         * @param {?} data
         * @return {?}
         */
        data => {
            /** @type {?} */
            const res = JSON.parse(data.d.ClientPeoplePickerSearchUser);
            return this.web.ensureUser(res[0].Key).then((/**
             * @param {?} result
             * @return {?}
             */
            result => {
                /** @type {?} */
                const d = (/** @type {?} */ (result.data));
                // compatibility:
                d.EMail = d.Email;
                d.ID = d.Id;
                return d;
            }));
        }));
    }
}
PwoScdSearchService.ɵfac = function PwoScdSearchService_Factory(t) { return new (t || PwoScdSearchService)(ɵngcc0.ɵɵinject('scdApiKey', 8), ɵngcc0.ɵɵinject('accessTokenKey', 8)); };
PwoScdSearchService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PwoScdSearchService, factory: PwoScdSearchService.ɵfac, providedIn: 'root' });
/** @nocollapse */
PwoScdSearchService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: ['scdApiKey',] }, { type: Optional }] },
    { type: String, decorators: [{ type: Inject, args: ['accessTokenKey',] }, { type: Optional }] }
];
/** @nocollapse */ PwoScdSearchService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PwoScdSearchService_Factory() { return new PwoScdSearchService(ɵɵinject("scdApiKey", 8), ɵɵinject("accessTokenKey", 8)); }, token: PwoScdSearchService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: ['scdApiKey']
            }, {
                type: Optional
            }] }, { type: String, decorators: [{
                type: Inject,
                args: ['accessTokenKey']
            }, {
                type: Optional
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    PwoScdSearchService.prototype.scdServiceUrl;
    /** @type {?} */
    PwoScdSearchService.prototype.authScdServiceUrl;
    /** @type {?} */
    PwoScdSearchService.prototype.spWeburl;
    /** @type {?} */
    PwoScdSearchService.prototype.web;
    /** @type {?} */
    PwoScdSearchService.prototype.apiKey;
    /** @type {?} */
    PwoScdSearchService.prototype.accessTokenKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef((/**
     * @return {?}
     */
    () => PwoScdComponent)),
    multi: true
};
/** @type {?} */
const CUSTOM_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef((/**
     * @return {?}
     */
    () => PwoScdComponent)),
    multi: true,
};
class PwoScdComponent {
    /**
     * @param {?} searchService
     */
    constructor(searchService) {
        this.searchService = searchService;
        this.hint = 'e.g. Email / Firstname Lastname / Lastname, Firstname / GID';
        this.forSP = false;
        this.multiple = true;
        this._value = '';
        this.userCtrl = new FormControl();
        this.selectedUsers = [];
        this.isLoading = false;
        this.disabled = false;
        this.userNotFound = false;
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.onTouched = (/**
         * @return {?}
         */
        () => { });
    }
    /**
     * @return {?}
     */
    get value() { return this._value; }
    /**
     * @param {?} v
     * @return {?}
     */
    set value(v) {
        if (v !== this._value) {
            this._value = v;
            if (this.multiple) {
                if (this.forSP) {
                    // output multiple users in SP format
                    this.onChange({
                        results: v
                    });
                }
                else {
                    // output mutiple users as array
                    this.onChange(v);
                }
            }
            else {
                // output single user
                this.onChange(v[0]);
            }
        }
    }
    /* Methods for ControlValueAccessor */
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (value) {
            if (this.multiple) {
                if (this.forSP) {
                    if (value.results === undefined) {
                        this.selectedUsers = [];
                    }
                    else {
                        if (typeof value.results !== 'object' || value.results.length === undefined) {
                            throw new Error('Value must be in { results: ISPUSer[] } format!');
                        }
                        this.selectedUsers = value.results;
                    }
                }
                else {
                    if (typeof value !== 'object' || value.length === undefined) {
                        throw new Error('Value must be an array of IScdUser objects!');
                    }
                    this.selectedUsers = value;
                }
            }
            else {
                if (typeof value !== 'object') {
                    throw new Error('Value must be an array of ' + this.forSP ? 'ISPUser' : 'IScdUser' + ' objects!');
                }
                this.selectedUsers = [value];
            }
        }
        else {
            this.selectedUsers = [];
        }
        this.update();
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @param {?} control
     * @return {?}
     */
    validate(control) {
        // Custom validator is necessary because of SharePoints { result: [] } format
        return this.isValid() ? null : { required: true };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.scdSearchResult = new BehaviorSubject([]);
        this.userCtrl.valueChanges.pipe(debounceTime(225), distinctUntilChanged(), filter((/**
         * @param {?} val
         * @return {?}
         */
        val => val && val.length > 0))).subscribe((/**
         * @param {?} term
         * @return {?}
         */
        term => {
            this.isLoading = true;
            this.searchService.searchUser(term).then((/**
             * @param {?} result
             * @return {?}
             */
            (result) => {
                if (this.forSP && result) {
                    // Hide users without email addresses because they can't be added to the ActiveDirectory anyways
                    result = result.filter((/**
                     * @param {?} p
                     * @return {?}
                     */
                    p => p.mail && p.mail.length > 0));
                }
                /** @type {?} */
                const filteredResults = this.filterScdSearch(result);
                this.scdSearchResult.next(filteredResults);
                this.isLoading = false;
            }));
        }));
    }
    /**
     * @param {?} result
     * @return {?}
     */
    filterScdSearch(result) {
        if (!this.filter) {
            return result;
        }
        return this.filter.reduce((/**
         * @param {?} filteredResults
         * @param {?} attributeFilter
         * @return {?}
         */
        (filteredResults, attributeFilter) => filteredResults.filter((/**
         * @param {?} person
         * @return {?}
         */
        person => !person[attributeFilter.attribute] || person[attributeFilter.attribute] === attributeFilter.value))), [...result]);
    }
    /**
     * @return {?}
     */
    blur() {
        this.onTouched();
        this.isValid();
    }
    /**
     * @return {?}
     */
    isValid() {
        /** @type {?} */
        const isValid = this.required === undefined || this.selectedUsers.length > 0;
        this.chipList.errorState = (this.userCtrl.touched || this.userCtrl.dirty) && !isValid;
        return isValid;
    }
    /**
     * @param {?} user
     * @return {?}
     */
    remove(user) {
        if (this.multiple) {
            /** @type {?} */
            const index = this.selectedUsers.indexOf(user);
            if (index >= 0) {
                this.selectedUsers.splice(index, 1);
                this.update();
            }
        }
        else {
            this.selectedUsers = [];
            this.update();
        }
        this.getFocus();
    }
    // clear() {
    //   this.selectedUsers = [];
    //   this.update();
    //   this.getFocus();
    // }
    /**
     * @return {?}
     */
    getFocus() {
        // wait until the input is visible again, otherwise focus won't work
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.userInput.nativeElement.focus();
        }));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    selected(event) {
        /** @type {?} */
        const user = event.option.value;
        this.scdSearchResult.next([]);
        // this.userCtrl.setValue(null);
        this.userInput.nativeElement.value = '';
        if (this.forSP) {
            this.loadSPUser(user);
        }
        else {
            // Same display style as SP User
            user.Title = `${user.surName}, ${user.firstName} (${user.department})`;
            this.updateSelected(user);
        }
    }
    /**
     * @param {?} user
     * @return {?}
     */
    loadSPUser(user) {
        this.isLoading = true;
        this.searchService.getSPUser(user).then((/**
         * @param {?} spUser
         * @return {?}
         */
        (spUser) => {
            this.isLoading = false;
            this.updateSelected(spUser);
        })).catch((/**
         * @param {?} err
         * @return {?}
         */
        err => err.response.json())).then((/**
         * @param {?} err
         * @return {?}
         */
        err => {
            if (err && err.error) {
                if (err.error.code === '-2146232832, Microsoft.SharePoint.SPException') {
                    // User not found in Active Directory
                    this.userNotFound = true;
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        this.userNotFound = false;
                    }), 3000);
                }
            }
        }));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateSelected(value) {
        if (this.multiple) {
            this.selectedUsers.push(value);
        }
        else {
            this.selectedUsers = [value];
            this.userInput.nativeElement.blur();
        }
        this.update();
    }
    /**
     * @return {?}
     */
    update() {
        // Deep copy, otherwise angular won't run the validator function
        this.value = JSON.parse(JSON.stringify(this.selectedUsers));
    }
}
PwoScdComponent.ɵfac = function PwoScdComponent_Factory(t) { return new (t || PwoScdComponent)(ɵngcc0.ɵɵdirectiveInject(PwoScdSearchService)); };
PwoScdComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PwoScdComponent, selectors: [["pwo-scd"]], viewQuery: function PwoScdComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
        ɵngcc0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chipList = _t.first);
    } }, inputs: { hint: "hint", forSP: "forSP", multiple: "multiple", placeholder: "placeholder", required: "required", filter: "filter" }, features: [ɵngcc0.ɵɵProvidersFeature([CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, CUSTOM_VALIDATOR])], ngContentSelectors: _c3, decls: 17, vars: 13, consts: [[1, "scd-picker"], [3, "disabled", "required"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], [3, "hidden", "placeholder", "formControl", "matAutocomplete", "matChipInputFor", "blur"], ["userInput", ""], ["autoActiveFirstOption", "", 3, "optionSelected"], ["auto", "matAutocomplete"], ["class", "loading-indicator", "disabled", "", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], [3, "selectable", "removable", "removed"], ["matChipRemove", ""], ["disabled", "", 1, "loading-indicator"], ["mode", "indeterminate"], [3, "value"]], template: function PwoScdComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0)(1, "mat-label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "mat-chip-list", 1, 2);
        ɵngcc0.ɵɵtemplate(5, PwoScdComponent_mat_chip_5_Template, 4, 3, "mat-chip", 3);
        ɵngcc0.ɵɵelementStart(6, "input", 4, 5);
        ɵngcc0.ɵɵlistener("blur", function PwoScdComponent_Template_input_blur_6_listener() { return ctx.blur(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "mat-autocomplete", 6, 7);
        ɵngcc0.ɵɵlistener("optionSelected", function PwoScdComponent_Template_mat_autocomplete_optionSelected_8_listener($event) { return ctx.selected($event); });
        ɵngcc0.ɵɵtemplate(10, PwoScdComponent_mat_option_10_Template, 2, 0, "mat-option", 8);
        ɵngcc0.ɵɵtemplate(11, PwoScdComponent_mat_option_11_Template, 4, 4, "mat-option", 9);
        ɵngcc0.ɵɵpipe(12, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "mat-hint");
        ɵngcc0.ɵɵprojection(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "mat-error");
        ɵngcc0.ɵɵprojection(16, 1);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(4);
        const _r3 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.placeholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("required", ctx.required);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selectedUsers);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.multiple && ctx.selectedUsers.length === 1)("placeholder", ctx.hint)("formControl", ctx.userCtrl)("matAutocomplete", _r3)("matChipInputFor", _r0);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(12, 11, ctx.scdSearchResult));
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc3.MatError, ɵngcc3.MatFormField, ɵngcc3.MatHint, ɵngcc3.MatLabel, ɵngcc4.MatOption, ɵngcc2.FormControlDirective, ɵngcc5.MatChipList, ɵngcc5.MatChip, ɵngcc5.MatChipInput, ɵngcc5.MatChipRemove, ɵngcc6.MatAutocomplete, ɵngcc6.MatAutocompleteTrigger, ɵngcc7.MatIcon, ɵngcc8.MatProgressBar, ɵngcc1.AsyncPipe], styles: [".mat-autocomplete-panel{border-radius:0}.scd-picker[_ngcontent-%COMP%]{width:100%}.loading-indicator[_ngcontent-%COMP%]{height:unset;padding:0}"] });
/** @nocollapse */
PwoScdComponent.ctorParameters = () => [
    { type: PwoScdSearchService }
];
PwoScdComponent.propDecorators = {
    userInput: [{ type: ViewChild, args: ['userInput', { static: true },] }],
    chipList: [{ type: ViewChild, args: ['chipList', { static: true },] }],
    placeholder: [{ type: Input }],
    hint: [{ type: Input }],
    forSP: [{ type: Input }],
    multiple: [{ type: Input }],
    required: [{ type: Input }],
    filter: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdComponent, [{
        type: Component,
        args: [{ selector: 'pwo-scd', template: "<!-- <mat-form-field>\r\n  <input placeholder=\"{{placeholder}}\" type=\"text\" matInput [ngModel]=\"searchField\" [matAutocomplete]=\"auto\" [disabled]=\"disabled\">\r\n  <button *ngIf=\"enablePicker\" matSuffix aria-label=\"Select user\" (click)=\"openPicker()\">\r\n    <span class=\"icon--user-account\"></span>\r\n  </button>\r\n</mat-form-field>\r\n<mat-autocomplete #auto=\"matAutocomplete\">\r\n  <mat-option *ngFor=\"let item of searchResults\" [value]=\"item.display\" (onSelectionChange)=\"select(item)\">\r\n    {{ item.display }}\r\n  </mat-option>\r\n</mat-autocomplete>\r\n\r\n<mat-form-field>\r\n  <input matInput placeholder=\"Manager\" [matAutocomplete]=\"auto\" [ngModel]=\"project.Manager.name\"\r\n    (ngModelChange)=\"project.Manager = $event\" name=\"manager\">\r\n  <mat-autocomplete #auto=\"matAutocomplete\">\r\n    <mat-option *ngFor=\"let p of states\" [value]=\"state\">\r\n      <span>{{state.name}}</span>\r\n    </mat-option>\r\n  </mat-autocomplete>\r\n</mat-form-field> -->\r\n\r\n<mat-form-field class=\"scd-picker\">\r\n  <mat-label>{{ placeholder }}</mat-label>\r\n  <mat-chip-list #chipList [disabled]=\"disabled\" [required]=\"required\">\r\n    <mat-chip *ngFor=\"let user of selectedUsers\" [selectable]=\"true\" [removable]=\"true\"\r\n      (removed)=\"remove(user)\">\r\n      {{ user.Title }}\r\n      <mat-icon matChipRemove>cancel</mat-icon>\r\n    </mat-chip>\r\n    <input #userInput (blur)=\"blur()\" [hidden]=\"!multiple && selectedUsers.length === 1\" [placeholder]=\"hint\"\r\n      [formControl]=\"userCtrl\" [matAutocomplete]=\"auto\" [matChipInputFor]=\"chipList\">\r\n  </mat-chip-list>\r\n  <mat-autocomplete #auto=\"matAutocomplete\" autoActiveFirstOption (optionSelected)=\"selected($event)\">\r\n    <mat-option *ngIf=\"isLoading\" class=\"loading-indicator\" disabled>\r\n      <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\r\n    </mat-option>\r\n    <mat-option *ngFor=\"let user of scdSearchResult | async\" [value]=\"user\">\r\n      {{ user.firstName }} {{ user.surName }} | <small>{{ user.department }}</small>\r\n    </mat-option>\r\n  </mat-autocomplete>\r\n  <mat-hint>\r\n    <ng-content select=\"mat-hint\"></ng-content>\r\n  </mat-hint>\r\n  <mat-error>\r\n    <ng-content select=\"mat-error\"></ng-content>\r\n  </mat-error>\r\n</mat-form-field>\r\n<!-- <div class=\"mat-error\" *ngIf=\"userNotFound\">User not found in active directory</div> -->", providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR, CUSTOM_VALIDATOR], styles: ["::ng-deep .mat-autocomplete-panel{border-radius:0}.scd-picker{width:100%}.loading-indicator{height:unset;padding:0}"] }]
    }], function () { return [{ type: PwoScdSearchService }]; }, { hint: [{
            type: Input
        }], forSP: [{
            type: Input
        }], multiple: [{
            type: Input
        }], userInput: [{
            type: ViewChild,
            args: ['userInput', { static: true }]
        }], chipList: [{
            type: ViewChild,
            args: ['chipList', { static: true }]
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], filter: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    PwoScdComponent.prototype.userInput;
    /** @type {?} */
    PwoScdComponent.prototype.chipList;
    /** @type {?} */
    PwoScdComponent.prototype.placeholder;
    /** @type {?} */
    PwoScdComponent.prototype.hint;
    /** @type {?} */
    PwoScdComponent.prototype.forSP;
    /** @type {?} */
    PwoScdComponent.prototype.multiple;
    /** @type {?} */
    PwoScdComponent.prototype.required;
    /** @type {?} */
    PwoScdComponent.prototype.filter;
    /**
     * @type {?}
     * @private
     */
    PwoScdComponent.prototype._value;
    /** @type {?} */
    PwoScdComponent.prototype.userCtrl;
    /** @type {?} */
    PwoScdComponent.prototype.selectedUsers;
    /** @type {?} */
    PwoScdComponent.prototype.scdSearchResult;
    /** @type {?} */
    PwoScdComponent.prototype.isLoading;
    /** @type {?} */
    PwoScdComponent.prototype.disabled;
    /** @type {?} */
    PwoScdComponent.prototype.userNotFound;
    /** @type {?} */
    PwoScdComponent.prototype.onChange;
    /** @type {?} */
    PwoScdComponent.prototype.onTouched;
    /**
     * @type {?}
     * @private
     */
    PwoScdComponent.prototype.searchService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoScdPickerComponent {
    /**
     * @param {?} dialogRef
     * @param {?} scdService
     * @param {?} data
     */
    constructor(dialogRef, scdService, data) {
        this.dialogRef = dialogRef;
        this.scdService = scdService;
        this.data = data;
        this.displayedColumns = [
            'selected',
            'firstName',
            'surName',
            'eMail',
            'department'
        ];
        this.multiple = false;
        this.selectedUsers = [];
        if (data.multiple) {
            this.multiple = data.multiple;
        }
        if (this.data.users) {
            if (this.data.users instanceof Array) {
                this.selectedUsers = Object.assign([], this.data.users);
            }
            else {
                this.selectedUsers = [this.data.users];
            }
            if (this.selectedUsers.length) {
                this.scdService.searchByGID(this.selectedUsers).then((/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    this.selectedUsers = result;
                    for (const element of result) {
                        element.selected = true;
                    }
                    this.dataSource = new MatTableDataSource(result);
                }));
            }
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.dataSource = new MatTableDataSource();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    applyFilter(event) {
        if ((event.keyCode === 13 &&
            (this.firstName || this.surName || this.eMail)) ||
            (event.type === 'click' &&
                (this.firstName || this.surName || this.eMail))) {
            this.scdService
                .searchUser(this.firstName, this.surName, this.eMail)
                .then((/**
             * @param {?} result
             * @return {?}
             */
            result => {
                for (const element of result.person) {
                    element.selected = false;
                    for (const user of this.selectedUsers) {
                        if (element.gid === user.gid) {
                            element.selected = true;
                        }
                    }
                }
                this.dataSource = new MatTableDataSource(result.person);
            }));
        }
    }
    /**
     * @param {?} element
     * @param {?} event
     * @return {?}
     */
    changeSelected(element, event) {
        if (!this.multiple) {
            if (event.checked) {
                for (const user of this.dataSource.data) {
                    user.selected = false;
                }
                this.selectedUser = element;
                element.selected = event.checked;
            }
            else {
                delete this.selectedUser;
            }
        }
        else {
            element.selected = event.checked;
            if (event.checked) {
                this.selectedUsers.push(element);
            }
            else {
                this.selectedUsers.forEach((/**
                 * @param {?} item
                 * @param {?} idx
                 * @return {?}
                 */
                (item, idx) => {
                    if (item.gid === element.gid) {
                        this.selectedUsers.splice(idx, 1);
                        return;
                    }
                }));
            }
        }
    }
    /**
     * @param {?} element
     * @return {?}
     */
    remove(element) {
        this.changeSelected(element, { checked: false });
        for (const item of this.dataSource.data) {
            if (item === element) {
                item.selected = false;
            }
        }
    }
    /**
     * @return {?}
     */
    closeDialog() {
        if (this.multiple) {
            this.dialogRef.close(this.selectedUsers.map((/**
             * @param {?} e
             * @return {?}
             */
            e => ({
                scdGid: e.gid,
                scdName: e.surName + ', ' + e.firstName + ' (' + e.orgUnit + ')',
                scdEMail: e.mail
            }))));
        }
        else {
            this.dialogRef.close({
                scdGid: this.selectedUser.gid,
                scdName: this.selectedUser.surName +
                    ', ' +
                    this.selectedUser.firstName +
                    ' (' +
                    this.selectedUser.department +
                    ')',
                scdEMail: this.selectedUser.mail
            });
        }
    }
}
PwoScdPickerComponent.ɵfac = function PwoScdPickerComponent_Factory(t) { return new (t || PwoScdPickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc9.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(PwoScdService), ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
PwoScdPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PwoScdPickerComponent, selectors: [["pwo-scd-picker"]], decls: 56, vars: 7, consts: [[1, "grid-row"], [1, "grid-col", "grid-col--11", "space"], [1, "grid-col", "grid-col--1"], [3, "click"], [1, "material-icons", "close-btn"], [1, "grid-col", "grid-col--12"], [1, "grid-col", "grid-col--3"], ["matInput", "", "placeholder", "Vorname", 3, "ngModel", "keyup", "ngModelChange"], ["matInput", "", "placeholder", "Nachname", 3, "ngModel", "keyup", "ngModelChange"], [1, "grid-col", "grid-col--4"], ["matInput", "", "placeholder", "Mail", 3, "ngModel", "keyup", "ngModelChange"], [1, "grid-col", "grid-col--2"], [1, "options-group-item", "group-button", 3, "click"], [1, "options-group-item-info"], [1, "info-heading", "smaller-size"], [1, "grid-row", "scd-table-container"], ["matSort", "", 3, "dataSource"], ["table", ""], ["matColumnDef", "selected"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "surName"], ["matColumnDef", "firstName"], ["matColumnDef", "eMail"], ["matColumnDef", "department"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], ["class", "grid-row", 4, "ngIf"], [1, "grid-row", "buttons"], [1, "options-group-item", "group-button", "last-child", 3, "click"], [3, "ngModel", "ngModelChange", "change"], [4, "ngFor", "ngForOf"], [3, "removed", 4, "ngIf"], [3, "removed"], ["matChipRemove", "", 1, "material-icons"]], template: function PwoScdPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "p");
        ɵngcc0.ɵɵtext(3, "Person hinzuf\u00FCgen");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "div", 2)(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function PwoScdPickerComponent_Template_button_click_5_listener() { return ctx.dialogRef.close(); });
        ɵngcc0.ɵɵelementStart(6, "i", 4);
        ɵngcc0.ɵɵtext(7, "close");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(8, "div", 0)(9, "div", 5)(10, "div", 0)(11, "div", 6)(12, "mat-form-field")(13, "input", 7);
        ɵngcc0.ɵɵlistener("keyup", function PwoScdPickerComponent_Template_input_keyup_13_listener($event) { return ctx.applyFilter($event); })("ngModelChange", function PwoScdPickerComponent_Template_input_ngModelChange_13_listener($event) { return ctx.firstName = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(14, "div", 6)(15, "mat-form-field")(16, "input", 8);
        ɵngcc0.ɵɵlistener("keyup", function PwoScdPickerComponent_Template_input_keyup_16_listener($event) { return ctx.applyFilter($event); })("ngModelChange", function PwoScdPickerComponent_Template_input_ngModelChange_16_listener($event) { return ctx.surName = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(17, "div", 9)(18, "mat-form-field")(19, "input", 10);
        ɵngcc0.ɵɵlistener("keyup", function PwoScdPickerComponent_Template_input_keyup_19_listener($event) { return ctx.applyFilter($event); })("ngModelChange", function PwoScdPickerComponent_Template_input_ngModelChange_19_listener($event) { return ctx.eMail = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(20, "div", 11)(21, "a", 12);
        ɵngcc0.ɵɵlistener("click", function PwoScdPickerComponent_Template_a_click_21_listener($event) { return ctx.applyFilter($event); });
        ɵngcc0.ɵɵelementStart(22, "div", 13)(23, "p", 14);
        ɵngcc0.ɵɵtext(24, "Suche");
        ɵngcc0.ɵɵelementEnd()()()()();
        ɵngcc0.ɵɵelementStart(25, "div", 15)(26, "mat-table", 16, 17);
        ɵngcc0.ɵɵelementContainerStart(28, 18);
        ɵngcc0.ɵɵtemplate(29, PwoScdPickerComponent_mat_header_cell_29_Template, 1, 0, "mat-header-cell", 19);
        ɵngcc0.ɵɵtemplate(30, PwoScdPickerComponent_mat_cell_30_Template, 2, 1, "mat-cell", 20);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerStart(31, 21);
        ɵngcc0.ɵɵtemplate(32, PwoScdPickerComponent_mat_header_cell_32_Template, 3, 0, "mat-header-cell", 19);
        ɵngcc0.ɵɵtemplate(33, PwoScdPickerComponent_mat_cell_33_Template, 2, 1, "mat-cell", 20);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerStart(34, 22);
        ɵngcc0.ɵɵtemplate(35, PwoScdPickerComponent_mat_header_cell_35_Template, 3, 0, "mat-header-cell", 19);
        ɵngcc0.ɵɵtemplate(36, PwoScdPickerComponent_mat_cell_36_Template, 2, 1, "mat-cell", 20);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerStart(37, 23);
        ɵngcc0.ɵɵtemplate(38, PwoScdPickerComponent_mat_header_cell_38_Template, 3, 0, "mat-header-cell", 19);
        ɵngcc0.ɵɵtemplate(39, PwoScdPickerComponent_mat_cell_39_Template, 2, 1, "mat-cell", 20);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementContainerStart(40, 24);
        ɵngcc0.ɵɵtemplate(41, PwoScdPickerComponent_mat_header_cell_41_Template, 3, 0, "mat-header-cell", 19);
        ɵngcc0.ɵɵtemplate(42, PwoScdPickerComponent_mat_cell_42_Template, 2, 1, "mat-cell", 20);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵtemplate(43, PwoScdPickerComponent_mat_header_row_43_Template, 1, 0, "mat-header-row", 25);
        ɵngcc0.ɵɵtemplate(44, PwoScdPickerComponent_mat_row_44_Template, 1, 0, "mat-row", 26);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(45, PwoScdPickerComponent_div_45_Template, 3, 1, "div", 27);
        ɵngcc0.ɵɵelementStart(46, "div", 28)(47, "div", 9)(48, "a", 12);
        ɵngcc0.ɵɵlistener("click", function PwoScdPickerComponent_Template_a_click_48_listener() { return ctx.closeDialog(); });
        ɵngcc0.ɵɵelementStart(49, "div", 13)(50, "p", 14);
        ɵngcc0.ɵɵtext(51, "Best\u00E4tigen");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(52, "a", 29);
        ɵngcc0.ɵɵlistener("click", function PwoScdPickerComponent_Template_a_click_52_listener() { return ctx.dialogRef.close(); });
        ɵngcc0.ɵɵelementStart(53, "div", 13)(54, "p", 14);
        ɵngcc0.ɵɵtext(55, "Abbrechen");
        ɵngcc0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngModel", ctx.firstName);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.surName);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.eMail);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("dataSource", ctx.dataSource);
        ɵngcc0.ɵɵadvance(17);
        ɵngcc0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc10.MatCheckbox, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.MatFormField, ɵngcc11.MatInput, ɵngcc12.MatTable, ɵngcc12.MatHeaderCellDef, ɵngcc12.MatHeaderRowDef, ɵngcc12.MatColumnDef, ɵngcc12.MatCellDef, ɵngcc12.MatRowDef, ɵngcc12.MatHeaderCell, ɵngcc12.MatCell, ɵngcc12.MatHeaderRow, ɵngcc12.MatRow, ɵngcc5.MatChipList, ɵngcc5.MatChip, ɵngcc5.MatChipRemove], styles: [".mat-column-eMail[_ngcontent-%COMP%], .mat-column-firstName[_ngcontent-%COMP%], .mat-column-surName[_ngcontent-%COMP%]{flex-basis:5rem}.mat-column-selected[_ngcontent-%COMP%]{max-width:32px}.close-btn[_ngcontent-%COMP%]{float:right;cursor:pointer}mat-cell[_ngcontent-%COMP%]{overflow:visible}mat-chip[_ngcontent-%COMP%]{font-family:\"Siemens Sans Bold\"!important}button[_ngcontent-%COMP%]{background-color:transparent;border:none;outline:0}mat-form-field[_ngcontent-%COMP%]{width:100%}.scd-table-container[_ngcontent-%COMP%]{max-height:400px;overflow:auto}.mat-cell[_ngcontent-%COMP%]:first-child, .mat-header-cell[_ngcontent-%COMP%]:first-child{padding-left:0!important}.mat-standard-chip[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{margin-right:2px!important;margin-bottom:5px!important}.options-group-item[_ngcontent-%COMP%]{padding-left:9px!important}"] });
/** @nocollapse */
PwoScdPickerComponent.ctorParameters = () => [
    { type: MatDialogRef },
    { type: PwoScdService },
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdPickerComponent, [{
        type: Component,
        args: [{ selector: 'pwo-scd-picker', template: "<div class=\"grid-row\">\r\n  <div class=\"grid-col grid-col--11 space\">\r\n    <p>Person hinzuf\u00FCgen</p>\r\n  </div>\r\n  <div class=\"grid-col grid-col--1\">\r\n    <button (click)=\"dialogRef.close()\">\r\n      <i class=\"material-icons close-btn\">close</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n<div class=\"grid-row\">\r\n  <div class=\"grid-col grid-col--12\">\r\n    <div class=\"grid-row\">\r\n      <div class=\"grid-col grid-col--3\">\r\n        <mat-form-field>\r\n          <input matInput (keyup)=\"applyFilter($event)\" placeholder=\"Vorname\" [(ngModel)]=\"firstName\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"grid-col grid-col--3\">\r\n        <mat-form-field>\r\n          <input matInput (keyup)=\"applyFilter($event)\" placeholder=\"Nachname\" [(ngModel)]=\"surName\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"grid-col grid-col--4\">\r\n        <mat-form-field>\r\n          <input matInput (keyup)=\"applyFilter($event)\" placeholder=\"Mail\" [(ngModel)]=\"eMail\">\r\n        </mat-form-field>\r\n      </div>\r\n      <div class=\"grid-col grid-col--2\">\r\n        <a class=\"options-group-item group-button\" (click)=\"applyFilter($event)\">\r\n          <div class=\"options-group-item-info\">\r\n            <p class=\"info-heading smaller-size\">Suche</p>\r\n          </div>\r\n        </a>\r\n      </div>\r\n      <!-- <div class=\"grid-col grid-col--2\">\r\n        <i (click)=\"applyFilter($event)\" class=\"material-icons\">\r\n          search\r\n        </i>\r\n      </div> -->\r\n    </div>\r\n    <div class=\"grid-row scd-table-container\">\r\n      <mat-table #table [dataSource]=\"dataSource\" matSort>\r\n        <ng-container matColumnDef=\"selected\">\r\n          <mat-header-cell *matHeaderCellDef></mat-header-cell>\r\n          <mat-cell *matCellDef=\"let element\">\r\n            <mat-checkbox [(ngModel)]=\"element.selected\" (change)=\"changeSelected(element, $event)\"></mat-checkbox>\r\n          </mat-cell>\r\n        </ng-container>\r\n        <ng-container matColumnDef=\"surName\">\r\n          <mat-header-cell *matHeaderCellDef><span>Nachname</span></mat-header-cell>\r\n          <mat-cell *matCellDef=\"let element\">{{element.surName}}</mat-cell>\r\n        </ng-container>\r\n        <ng-container matColumnDef=\"firstName\">\r\n          <mat-header-cell *matHeaderCellDef><span>Vorname</span></mat-header-cell>\r\n          <mat-cell *matCellDef=\"let element\">{{element.firstName}}</mat-cell>\r\n        </ng-container>\r\n        <ng-container matColumnDef=\"eMail\">\r\n          <mat-header-cell *matHeaderCellDef><span>Mail</span></mat-header-cell>\r\n          <mat-cell *matCellDef=\"let element\">{{element.mail}}</mat-cell>\r\n        </ng-container>\r\n        <ng-container matColumnDef=\"department\">\r\n          <mat-header-cell *matHeaderCellDef><span>Abteilung</span></mat-header-cell>\r\n          <mat-cell *matCellDef=\"let element\">{{element.department}}</mat-cell>\r\n        </ng-container>\r\n        <mat-header-row *matHeaderRowDef=\"displayedColumns\"></mat-header-row>\r\n        <mat-row *matRowDef=\"let row; columns: displayedColumns;\"></mat-row>\r\n      </mat-table>\r\n    </div>\r\n\r\n    <div *ngIf=\"multiple\" class=\"grid-row\">\r\n      <mat-chip-list>\r\n        <ng-container *ngFor=\"let user of selectedUsers\">\r\n          <mat-chip *ngIf=\"user.firstName\" (removed)=\"changeSelected(user, {checked: false})\">\r\n            {{user.firstName + ' ' + user.surName || user.name}}\r\n            <i class=\"material-icons\" matChipRemove>cancel</i>\r\n          </mat-chip>\r\n        </ng-container>\r\n\r\n      </mat-chip-list>\r\n    </div>\r\n\r\n    <div class=\"grid-row buttons\">\r\n      <div class=\"grid-col grid-col--4\">\r\n        <a class=\"options-group-item group-button\" (click)=\"closeDialog()\">\r\n          <div class=\"options-group-item-info\">\r\n            <p class=\"info-heading smaller-size\">Best\u00E4tigen</p>\r\n          </div>\r\n        </a>\r\n        <a class=\"options-group-item group-button last-child\" (click)=\"dialogRef.close()\">\r\n          <div class=\"options-group-item-info\">\r\n            <p class=\"info-heading smaller-size\">Abbrechen</p>\r\n          </div>\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [".mat-column-eMail,.mat-column-firstName,.mat-column-surName{flex-basis:5rem}.mat-column-selected{max-width:32px}.close-btn{float:right;cursor:pointer}mat-cell{overflow:visible}mat-chip{font-family:\"Siemens Sans Bold\"!important}button{background-color:transparent;border:none;outline:0}mat-form-field{width:100%}.scd-table-container{max-height:400px;overflow:auto}.mat-cell:first-child,.mat-header-cell:first-child{padding-left:0!important}.mat-standard-chip .mat-chip-remove{margin-right:2px!important;margin-bottom:5px!important}.options-group-item{padding-left:9px!important}"] }]
    }], function () { return [{ type: ɵngcc9.MatDialogRef }, { type: PwoScdService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();
if (false) {
    /** @type {?} */
    PwoScdPickerComponent.prototype.displayedColumns;
    /** @type {?} */
    PwoScdPickerComponent.prototype.dataSource;
    /** @type {?} */
    PwoScdPickerComponent.prototype.firstName;
    /** @type {?} */
    PwoScdPickerComponent.prototype.surName;
    /** @type {?} */
    PwoScdPickerComponent.prototype.eMail;
    /** @type {?} */
    PwoScdPickerComponent.prototype.department;
    /** @type {?} */
    PwoScdPickerComponent.prototype.selectedUser;
    /** @type {?} */
    PwoScdPickerComponent.prototype.multiple;
    /** @type {?} */
    PwoScdPickerComponent.prototype.selectedUsers;
    /** @type {?} */
    PwoScdPickerComponent.prototype.dialogRef;
    /**
     * @type {?}
     * @private
     */
    PwoScdPickerComponent.prototype.scdService;
    /** @type {?} */
    PwoScdPickerComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoScdPeopleAutocompleteComponent {
    /**
     * @param {?} searchService
     * @param {?} scdDialog
     */
    constructor(searchService, scdDialog) {
        this.searchService = searchService;
        this.scdDialog = scdDialog;
        this.userChange = new EventEmitter();
        this.disabled = false;
        this.enablePicker = false;
        this.searchField = new FormControl();
        this.removable = true;
        this.onTextChange = (/**
         * @param {?} txt
         * @return {?}
         */
        (txt) => {
            this.searchResults = [];
            if (!txt) {
                return this.searchResults;
            }
            return this.searchService.searchUser(txt).then((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                this.searchResults = res.map((/**
                 * @param {?} el
                 * @return {?}
                 */
                (el) => {
                    el.display = el.firstName + ' ' + el.surName;
                    return el;
                }));
                return this.searchResults;
            }));
        });
    }
    /**
     * @param {?} user
     * @return {?}
     */
    set user(user) {
        if (user) {
            this.searchField.setValue(user.Title);
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.searchField.valueChanges
            .pipe(debounceTime(225), distinctUntilChanged())
            .subscribe((/**
         * @param {?} term
         * @return {?}
         */
        term => {
            this.searchResultsO = this.onTextChange(term);
        }));
    }
    /**
     * @param {?} item
     * @return {?}
     */
    select(item) {
        this.searchService.getSPUser(item).then((/**
         * @param {?} user
         * @return {?}
         */
        user => {
            this.user = user;
            this.userChange.emit(user);
        }));
    }
    /**
     * @return {?}
     */
    openPicker() {
        /** @type {?} */
        const dialogRef = this.scdDialog.open(PwoScdPickerComponent, {
            disableClose: false,
            panelClass: 'dialog-default',
            hasBackdrop: true,
            width: '1100px',
            data: {
                name: 'Confirm',
                users: [],
                multiple: false
            }
        });
        dialogRef.afterClosed().subscribe((/**
         * @param {?} users
         * @return {?}
         */
        users => {
            console.log('dialog closed', users);
        }));
    }
}
PwoScdPeopleAutocompleteComponent.ɵfac = function PwoScdPeopleAutocompleteComponent_Factory(t) { return new (t || PwoScdPeopleAutocompleteComponent)(ɵngcc0.ɵɵdirectiveInject(PwoScdSearchService), ɵngcc0.ɵɵdirectiveInject(ɵngcc9.MatDialog)); };
PwoScdPeopleAutocompleteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PwoScdPeopleAutocompleteComponent, selectors: [["pwo-scd-autocomplete"]], inputs: { disabled: "disabled", enablePicker: "enablePicker", user: "user", placeholder: "placeholder" }, outputs: { userChange: "userChange" }, decls: 6, vars: 9, consts: [[3, "ngClass"], ["type", "text", "matInput", "", 3, "placeholder", "formControl", "matAutocomplete", "disabled"], ["matSuffix", "", "aria-label", "Select user", 3, "click", 4, "ngIf"], ["auto", "matAutocomplete"], [3, "value", "onSelectionChange", 4, "ngFor", "ngForOf"], ["matSuffix", "", "aria-label", "Select user", 3, "click"], [1, "icon--user-account"], [3, "value", "onSelectionChange"]], template: function PwoScdPeopleAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0);
        ɵngcc0.ɵɵelement(1, "input", 1);
        ɵngcc0.ɵɵtemplate(2, PwoScdPeopleAutocompleteComponent_button_2_Template, 2, 0, "button", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "mat-autocomplete", null, 3);
        ɵngcc0.ɵɵtemplate(5, PwoScdPeopleAutocompleteComponent_mat_option_5_Template, 2, 2, "mat-option", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c4, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵproperty("formControl", ctx.searchField)("matAutocomplete", _r1)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enablePicker);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.searchResults);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc3.MatFormField, ɵngcc3.MatSuffix, ɵngcc4.MatOption, ɵngcc11.MatInput, ɵngcc2.FormControlDirective, ɵngcc6.MatAutocomplete, ɵngcc6.MatAutocompleteTrigger], styles: [".mat-form-field[_ngcontent-%COMP%]{width:100%}.mat-form-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:none;padding-left:0}"] });
/** @nocollapse */
PwoScdPeopleAutocompleteComponent.ctorParameters = () => [
    { type: PwoScdSearchService },
    { type: MatDialog }
];
PwoScdPeopleAutocompleteComponent.propDecorators = {
    userChange: [{ type: Output }],
    user: [{ type: Input }],
    placeholder: [{ type: Input }],
    disabled: [{ type: Input }],
    enablePicker: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdPeopleAutocompleteComponent, [{
        type: Component,
        args: [{ selector: 'pwo-scd-autocomplete', template: "<mat-form-field [ngClass]=\"{'disabled': disabled}\">\r\n  <input placeholder=\"{{placeholder}}\" type=\"text\" matInput [formControl]=\"searchField\" [matAutocomplete]=\"auto\" [disabled]=\"disabled\">\r\n  <button *ngIf=\"enablePicker\" matSuffix aria-label=\"Select user\" (click)=\"openPicker()\">\r\n    <span class=\"icon--user-account\"></span>\r\n  </button>\r\n</mat-form-field>\r\n<mat-autocomplete #auto=\"matAutocomplete\">\r\n  <mat-option *ngFor=\"let item of searchResults\" [value]=\"item.display\" (onSelectionChange)=\"select(item)\">\r\n    {{ item.display }}\r\n  </mat-option>\r\n</mat-autocomplete>", styles: [".mat-form-field{width:100%}.mat-form-field input{border:none;padding-left:0}"] }]
    }], function () { return [{ type: PwoScdSearchService }, { type: ɵngcc9.MatDialog }]; }, { userChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], enablePicker: [{
            type: Input
        }], user: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.userChange;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.placeholder;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.disabled;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.enablePicker;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.searchResults;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.searchTerm;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.searchField;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.searchResultsO;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.removable;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.onTextChange;
    /**
     * @type {?}
     * @private
     */
    PwoScdPeopleAutocompleteComponent.prototype.searchService;
    /** @type {?} */
    PwoScdPeopleAutocompleteComponent.prototype.scdDialog;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoScdModule {
}
PwoScdModule.ɵfac = function PwoScdModule_Factory(t) { return new (t || PwoScdModule)(); };
PwoScdModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PwoScdModule });
PwoScdModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatProgressBarModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoScdModule, [{
        type: NgModule,
        args: [{
                declarations: [PwoScdComponent, PwoScdPickerComponent, PwoScdPeopleAutocompleteComponent],
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatCheckboxModule,
                    FormsModule,
                    MatButtonModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatInputModule,
                    ReactiveFormsModule,
                    MatTableModule,
                    MatChipsModule,
                    MatDialogModule,
                    MatProgressSpinnerModule,
                    MatTabsModule,
                    MatDatepickerModule,
                    MatAutocompleteModule,
                    MatIconModule,
                    MatProgressBarModule
                ],
                exports: [PwoScdComponent, PwoScdPeopleAutocompleteComponent],
                entryComponents: [PwoScdPickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PwoScdModule, { declarations: function () { return [PwoScdComponent, PwoScdPickerComponent, PwoScdPeopleAutocompleteComponent]; }, imports: function () { return [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatProgressBarModule]; }, exports: function () { return [PwoScdComponent, PwoScdPeopleAutocompleteComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IScdUser() { }
if (false) {
    /** @type {?} */
    IScdUser.prototype.gid;
    /** @type {?} */
    IScdUser.prototype.mail;
    /** @type {?} */
    IScdUser.prototype.surName;
    /** @type {?} */
    IScdUser.prototype.firstName;
    /** @type {?} */
    IScdUser.prototype.displayName;
    /** @type {?} */
    IScdUser.prototype.department;
    /** @type {?} */
    IScdUser.prototype.location;
    /** @type {?} */
    IScdUser.prototype.Title;
}
/**
 * @record
 */
function ISPUser() { }
if (false) {
    /** @type {?} */
    ISPUser.prototype.Id;
    /** @type {?} */
    ISPUser.prototype.ID;
    /** @type {?} */
    ISPUser.prototype.Title;
    /** @type {?} */
    ISPUser.prototype.LoginName;
    /** @type {?} */
    ISPUser.prototype.Email;
    /** @type {?} */
    ISPUser.prototype.EMail;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PwoScdModule, PwoScdPickerComponent, PwoScdSearchService, PwoScdService, PwoScdComponent as ɵa, PwoScdPeopleAutocompleteComponent as ɵb };

